(function ( $ ) {
	document.addEventListener( 'DOMContentLoaded', function () {

		setHeaderHeight();
		window.addEventListener('resize', () => setHeaderHeight(), { passive: true });
		lazyLoadMap();

		//Добавляем обёртку для таблиц в описании товара
		if (isExist('.single-product__desc table')) {
			document.querySelectorAll('.single-product__desc table').forEach((table) => {
				if (table.closest('.wp-block-table')) return;

				const wrap = document.createElement('div');
				wrap.className = 'wp-block-table';
				table.parentNode.insertBefore(wrap, table);
				wrap.appendChild(table);
			});
		}

		// Хлебные крошки: горизонтальный скролл + стрелки + старт с конца
		if (isExist('.breadcrumbs')) {
			document.querySelectorAll('.breadcrumbs').forEach((nav) => {
				const track = nav.querySelector(':scope > span');
				if (!track) return;

				const btnPrev = document.createElement('button');
				btnPrev.type = 'button';
				btnPrev.className = 'breadcrumbs__arrow breadcrumbs__arrow--prev';
				btnPrev.setAttribute('aria-label', 'Листать назад');
				btnPrev.hidden = true;

				const btnNext = document.createElement('button');
				btnNext.type = 'button';
				btnNext.className = 'breadcrumbs__arrow breadcrumbs__arrow--next';
				btnNext.setAttribute('aria-label', 'Листать вперёд');
				btnNext.hidden = true;

				nav.appendChild(btnPrev);
				nav.appendChild(btnNext);

				const step = 160;

				const updateArrows = () => {
					const overflowing = track.scrollWidth > track.clientWidth + 1;
					nav.classList.toggle('has-overflow', overflowing);
					btnPrev.hidden = !overflowing || track.scrollLeft <= 0;
					btnNext.hidden = !overflowing || track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
				};

				// Показать с конца
				track.scrollLeft = track.scrollWidth;

				btnPrev.addEventListener('click', () => {
					track.scrollLeft -= step;
				});

				btnNext.addEventListener('click', () => {
					track.scrollLeft += step;
				});

				track.addEventListener('scroll', updateArrows, { passive: true });
				window.addEventListener('resize', updateArrows, { passive: true });

				updateArrows();
			});
		}

		// Перемещаем крестик cookie наружу из button-holder, чтобы позиционировать его вне контейнера
		const cookieBar = document.querySelector('#moove_gdpr_cookie_info_bar');
		if (cookieBar) {
			const closeBtn = cookieBar.querySelector('.moove-gdpr-infobar-close-btn.gdpr-fbo-3');
			if (closeBtn) {
				cookieBar.appendChild(closeBtn);
			}
		}

		Fancybox.bind('[data-fancybox]', {
			// Your custom options
		});

		// Попап поиска (кнопка есть и в шапке, и на главной странице)
		const openSearchPopup = () => {
			Fancybox.show([{ src: '#search-popup', type: 'inline' }]);
			setTimeout(() => {
				const input = document.querySelector('.fancybox__content .search-popup__input');
				if (input) input.focus();
				window.CarrotsBoxSearch?.reset();
				window.CarrotsBoxSearch?.render();
			}, 200);
		};

		document.querySelectorAll('.header-menu-search, .first__nav-search').forEach((btn) => {
			btn.addEventListener('click', openSearchPopup);
		});

		// Попап формы «Коммерческое предложение»
		document.querySelectorAll('[data-target="form-offer"]').forEach((btn) => {
			btn.addEventListener('click', (event) => {
				event.preventDefault();
				Fancybox.show([{ src: '#offer-popup', type: 'inline' }]);
			});
		});

		// Попап формы «Оставить заявку»
		document.querySelectorAll('[data-target="form-callback"]').forEach((btn) => {
			btn.addEventListener('click', (event) => {
				event.preventDefault();
				Fancybox.show([{ src: '#callback-popup', type: 'inline' }]);
			});
		});

		// Попап формы «Задать вопрос»
		document.querySelectorAll('[data-target="form-question"]').forEach((btn) => {
			btn.addEventListener('click', (event) => {
				event.preventDefault();
				Fancybox.show([{ src: '#question-popup', type: 'inline' }]);
			});
		});

		// Маска на телефон
		$( "input[name*=-phone]" ).mask( "+9 (999) 999-9999" );

		// анимация лейблов форм
		if ( isExist( '.form-wrapper' ) ) {
			const forms = document.querySelectorAll( '.form-wrapper' );

			forms.forEach( ( form ) => {
				const inputs = form.querySelectorAll( 'input, textarea' );
				inputs.forEach( ( input ) => {
					input.onfocus = function ( e ) {
						const label = input.closest( 'label' );
						label.classList.add( 'active' )
					}
					input.onblur = function ( e ) {
						const label = input.closest( 'label' );
						label.classList.remove( 'active' )
					}
				} );
			} );
		}

		// Оборачиваем изображения в ссылки
		if (isExist('.container-text .wp-block-image')) {
			let wpImage = document.querySelectorAll('.container-text .wp-block-image');

			wpImage.forEach((image) => {
				const imgElement = image.querySelector('img'),
					figcaptionElement = image.querySelector('figcaption'),
					src = imgElement.src;

				if (!image.parentElement.classList.contains('wp-block-gallery')) {

					if (imgElement && figcaptionElement) {
						let org_html = image.innerHTML;

						org_html = org_html.replace(/<figcaption\b[^>]*>.*?<\/figcaption>/i, '');

						image.innerHTML = `<a href="${src}" data-fancybox>${org_html}</a>${figcaptionElement.outerHTML}`;
					} else {
						const org_html = image.innerHTML;
						image.innerHTML = `<a href="${src}" data-fancybox>${org_html}</a>`;
					}
				}
			});
		}

		// Галереи на дефолтной странице
		if (isExist('.container-text .wp-block-gallery')) {
			let wpGalleries = document.querySelectorAll('.container-text .wp-block-gallery');

			wpGalleries.forEach((gallery, index) => {
				let wpImages = gallery.querySelectorAll('.wp-block-image');
				let minHeight = Number.MAX_SAFE_INTEGER;

				wpImages.forEach((image) => {
					const imgElement = image.querySelector('img'),
						figcaptionElement = image.querySelector('figcaption'),
						src = imgElement.src;

					if (imgElement && figcaptionElement) {
						let org_html = image.innerHTML;

						org_html = org_html.replace(/<figcaption\b[^>]*>.*?<\/figcaption>/i, '');

						image.innerHTML = `<a href="${src}" data-fancybox="gallery-${index}">${org_html}</a>${figcaptionElement.outerHTML}`;
					} else {
						const org_html = image.innerHTML;
						image.innerHTML = `<a href="${src}" data-fancybox="gallery-${index}">${org_html}</a>`;
					}

					// Добавление проверки изображений на высоту и присваивания всем минимальной высоты
					const height = image.offsetHeight;

					if (height < minHeight) {
						minHeight = height;
					}
				});

				wpImages.forEach((img) => {
					img.style.height = `${minHeight}px`;
				});
			});
		}


		// валидация форм
		let forms = document.querySelectorAll('.wpcf7');

		for (let form of forms) {
			form.addEventListener('wpcf7mailsent', function () {
				Fancybox.close();
				Fancybox.show([{src: '#success-popup', type: "inline"}]);
			});

			form.addEventListener('wpcf7mailfailed', function () {
				Fancybox.close();
				Fancybox.show([{src: '#failed-popup', type: "inline"}]);
			});
		}

		// Шапка на главной — показывать после first__inner 
		if (isHome()) {
			const header = document.querySelector('.header');
			const firstInner = document.querySelector('.first__inner');

			if (header && firstInner) {
				const updateHeaderVisibility = () => {
					if (isMobile()) {
						header.classList.remove('is-visible');
						return;
					}

					header.classList.toggle('is-visible', firstInner.getBoundingClientRect().bottom <= 0);
				};

				updateHeaderVisibility();
				window.addEventListener('scroll', updateHeaderVisibility, { passive: true });
				window.addEventListener('resize', updateHeaderVisibility, { passive: true });
			}
		}

		// FAQ-аккордеон
		if (isExist('.faq__item')) {
			document.querySelectorAll('.faq__item').forEach((item) => {
				const title = item.querySelector('.faq__item-title');
				const content = item.querySelector('.faq__item-content');

				if (!title || !content) {
					return;
				}

				if (!content.querySelector('.faq__item-content-inner')) {
					const inner = document.createElement('div');
					inner.className = 'faq__item-content-inner';
					inner.innerHTML = content.innerHTML;
					content.innerHTML = '';
					content.appendChild(inner);
				}

				title.addEventListener('click', () => {
					item.classList.toggle('is-open');
				});
			});
		}

		// Хотспоты на изображении
		if (isExist('.hotspot-image')) {
			document.querySelectorAll('.hotspot-image').forEach((image) => {
				const points = image.querySelectorAll('.hotspot-image__point');

				// Мобилка: тап по точке показывает/скрывает тултип
				points.forEach((point) => {
					point.addEventListener('click', (e) => {
						if (window.matchMedia('(hover: none)').matches) {
							e.stopPropagation();
							const isActive = point.classList.contains('is-active');
							points.forEach((p) => p.classList.remove('is-active'));
							if (!isActive) {
								point.classList.add('is-active');
							}
						}
					});
				});

				document.addEventListener('click', () => {
					points.forEach((p) => p.classList.remove('is-active'));
				});

				// Хелпер координат для авторизованных (если родитель .gallery имеет класс --helper)
				const coords = image.querySelector('.hotspot-image__coords');
				const isHelper = image.closest('.gallery--hotspot-helper') || image.classList.contains('hotspot-image--helper');
				if (coords && isHelper) {
					image.addEventListener('mousemove', (e) => {
						const rect = image.getBoundingClientRect();
						const x = ((e.clientX - rect.left) / rect.width * 100).toFixed(1);
						const y = ((e.clientY - rect.top) / rect.height * 100).toFixed(1);
						coords.textContent = 'X: ' + x + '% / Y: ' + y + '%';
					});
				}
			});
		}

		if (isExist('.archive-portfolio__content') && typeof themeAjax !== 'undefined') {
			const portfolioContent = document.querySelector('.archive-portfolio__content');
			const portfolioItems = portfolioContent.querySelector('.archive-portfolio__items');
			const portfolioLoadMore = portfolioContent.querySelector('.archive-portfolio__load-more');
			const portfolioFilters = document.querySelectorAll('.archive-portfolio__filter-link');
			let portfolioLoading = false;

			const setPortfolioLoading = (isLoading) => {
				portfolioLoading = isLoading;
				portfolioContent.classList.toggle('is-loading', isLoading);

				if (portfolioLoadMore) {
					portfolioLoadMore.disabled = isLoading;
					const text = portfolioLoadMore.querySelector('span');

					if (text) {
						text.textContent = isLoading ? 'Загрузка...' : 'Показать ещё';
					}
				}
			};

			const updatePortfolioState = (direction, page, maxPages) => {
				portfolioContent.dataset.currentDirection = direction;
				portfolioContent.dataset.currentPage = page;
				portfolioContent.dataset.maxPages = maxPages;

				if (portfolioLoadMore) {
					portfolioLoadMore.hidden = page >= maxPages;
				}
			};

			const requestPortfolio = (direction, page, append = false) => {
				if (portfolioLoading) {
					return;
				}

				setPortfolioLoading(true);

				const formData = new FormData();
				formData.append('action', 'load_portfolio');
				formData.append('nonce', themeAjax.nonce);
				formData.append('direction', direction);
				formData.append('page', page);

				fetch(themeAjax.ajaxUrl, {
					method: 'POST',
					body: formData,
					credentials: 'same-origin',
				})
					.then((response) => response.json())
					.then((response) => {
						if (!response.success) {
							throw new Error('Portfolio ajax failed');
						}

						const html = response.data.html || '<p class="archive-portfolio__empty">Проекты не найдены</p>';

						if (append) {
							portfolioItems.insertAdjacentHTML('beforeend', html);
						} else {
							portfolioItems.innerHTML = html;
						}

						updatePortfolioState(direction, response.data.page, response.data.max_pages);
					})
					.catch(() => {
						if (!append) {
							portfolioItems.innerHTML = '<p class="archive-portfolio__empty">Не удалось загрузить проекты</p>';
						}
					})
					.finally(() => {
						setPortfolioLoading(false);
					});
			};

			portfolioFilters.forEach((filter) => {
				filter.addEventListener('click', (event) => {
					event.preventDefault();

					const direction = filter.dataset.direction || '';
					const url = new URL(filter.href);

					portfolioFilters.forEach((item) => item.classList.remove('is-active'));
					filter.classList.add('is-active');
					window.history.pushState({}, '', url);
					requestPortfolio(direction, 1);
				});
			});

			if (portfolioLoadMore) {
				portfolioLoadMore.addEventListener('click', () => {
					const direction = portfolioContent.dataset.currentDirection || '';
					const nextPage = parseInt(portfolioContent.dataset.currentPage || '1', 10) + 1;

					requestPortfolio(direction, nextPage, true);
				});
			}
		}

		// Бургер-меню
		const burger = document.querySelector('.header-burger');
		if (burger) {
			const header = burger.closest('.header');
			burger.addEventListener('click', function () {
				const isOpen = header.classList.toggle('is-open');
				burger.setAttribute('aria-expanded', isOpen);
				burger.setAttribute('aria-label', isOpen ? 'Закрыть меню' : 'Открыть меню');
			});
		}

		sal({
			threshold: .1,
		});

		// Слайдеры
		const swiper = new Swiper('.firstSlider', {
			slidesPerView: 1,
			loop: false,
			pagination: {
				el: '.firstSlider .pagination',
				type: 'fraction',
			},
			navigation: {
				nextEl: '.firstSlider .button-next',
				prevEl: '.firstSlider .button-prev',
			},
		});

		if (isExist('.advantagesSlider')) {
			new Swiper('.advantagesSlider', {
				slidesPerView: 1,
				spaceBetween: 12,
				autoplay: {
					delay: 3000,
				},
				loop: true,
				navigation: {
					nextEl: '.advantagesSlider .button-next',
					prevEl: '.advantagesSlider .button-prev',
				},
			});
		}

		const updateReviewsLinks = () => {
			document.querySelectorAll('.reviews__text-inner').forEach((inner) => {
				const text = inner.querySelector('.reviews__text');
				const link = inner.querySelector('.reviews__link');

				if (!text || !link) {
					return;
				}

				link.hidden = text.scrollHeight <= text.clientHeight + 1;
			});
		};

		if (isExist('.portfolioSlider')) {
			new Swiper('.portfolioSlider', {
				slidesPerView: 1,
				spaceBetween: 10,
				loop: false,
				pagination: {
					el: '.portfolioSlider .pagination',
					type: 'progressbar',
				},
				navigation: {
					nextEl: '.portfolioSlider .button-next',
					prevEl: '.portfolioSlider .button-prev',
				},
				breakpoints: {
					768: {
						slidesPerView: 2,
						spaceBetween: 14,
					},
					1201: {
						slidesPerView: 2,
						spaceBetween: 16,
					},
				},
			});
		}

		if (isExist('.reviewsSlider')) {
			const reviewsSlider = new Swiper('.reviewsSlider', {
				slidesPerView: 1,
				spaceBetween: 10,
				loop: false,
				pagination: {
					el: '.reviewsSlider .pagination',
					type: 'progressbar',
				},
				navigation: {
					nextEl: '.reviewsSlider .button-next',
					prevEl: '.reviewsSlider .button-prev',
				},
				breakpoints: {
					768: {
						slidesPerView: 2.5,
						spaceBetween: 14,
					},
					1201: {
						slidesPerView: 2.5,
						spaceBetween: 16,
					},
				},
				on: {
					init: updateReviewsLinks,
					resize: updateReviewsLinks,
					slideChange: updateReviewsLinks,
				},
			});

			updateReviewsLinks();
			window.addEventListener('resize', updateReviewsLinks, { passive: true });
		}
	} );
})( jQuery );